import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  settingLoading: false,
  languages: null,
  accountReport: null,
  investmentDropdown: null,
  investmentReport: null,
  passwordLoading: false,
  resetLoading: false,
  tradingSettingsDropdown: null,
  generalClientDetails: null,
  ticketing_history: null,
  ticketing_history_loading: false,
};

const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    setSettingLoading: (state, action) => {
      state.settingLoading = action.payload;
    },
    setLanguages: (state, action) => {
      state.languages = action.payload;
    },
    setAccountReport: (state, action) => {
      state.accountReport = action.payload;
    },
    setInvestmentReportDropdown: (state, action) => {
      state.investmentDropdown = action.payload;
    },
    setInvestmentReport: (state, action) => {
      state.investmentReport = action.payload;
    },
    setPasswordLoading: (state, action) => {
      state.passwordLoading = action.payload;
    },
    setResetLoading: (state, action) => {
      state.resetLoading = action.payload;
    },
    setTradingSettingsDropdown: (state, action) => {
      state.tradingSettingsDropdown = action.payload;
    },
    setGeneralClientDetails: (state, action) => {
      state.generalClientDetails = action.payload;
    },
    setTicketingHistory: (state, action) => {
      state.ticketing_history = action.payload;
    },
    setTicketingHistoryLoading: (state, action) => {
      state.ticketing_history_loading = action.payload;
    },
  },
});

export const {
  setSettingLoading,
  setLanguages,
  setAccountReport,
  setInvestmentReportDropdown,
  setInvestmentReport,
  setPasswordLoading,
  setResetLoading,
  setTradingSettingsDropdown,
  setGeneralClientDetails,
  setTicketingHistoryLoading,
  setTicketingHistory,
} = settingSlice.actions;
export default settingSlice.reducer;
